<template>
		<Search
			v-on:position-changed="positionChanged"
			v-on:search-submit="searchSubmit"
			/>

			<Teleport to="#garage-country-map">
			  <AppSmall />
			</Teleport>
</template>

<script setup lang="ts">

import AppSmall from '@/components/AppSmall.vue';
import Search from '@/components/Search.vue';
import type { Position } from '@/types.d';
import { inject } from 'vue';

let searchInputUrl = '';
let currentCountry = inject('current_country', undefined);

const generateDrupalGarageUrl = function(lat: number, lng: number, searchValue = '', countryCode?: string) {
	const searchParams = new URLSearchParams();
	const service = getSelectedService();
	searchParams.append('location', `${searchValue}|${lat}|${lng}`);

  if( service ){
    searchParams.append('type', `${service}`);
  }

	let url = `garages?${searchParams.toString()}`;
	if( countryCode ) {
		url = `${countryCode.toLowerCase()}/${url}`;
	}

//@ts-ignore
	return Drupal.url(url);
}

const getSelectedService = function(){
	let elm = document.querySelector('.js-hero-search-btn.is-active') as HTMLElement | null;
	let service =  elm?.dataset.service;

  return service;
}

const positionChanged = function(position: Position, { searchValue}: { searchValue?: string}) {
	searchInputUrl = generateDrupalGarageUrl(position.lat, position.lng, searchValue, currentCountry);
};

const searchSubmit = function() {
	if( searchInputUrl.length ) {
		window.location.href = searchInputUrl;
	}
}

</script>